import React from 'react';
import { cn } from '../../utils/cn';

const StandardTextarea = ({ 
  label,
  error,
  helperText,
  rows = 4,
  className,
  ...props 
}) => {
  const baseStyles = 'w-full px-4 py-3 border rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-teal-500 disabled:bg-gray-100 disabled:cursor-not-allowed resize-vertical';
  
  const stateStyles = error 
    ? 'border-red-500 focus:border-red-500' :'border-gray-300 focus:border-teal-500';
  
  return (
    <div className="w-full">
      {label && (
        <label className="block text-sm font-medium text-gray-700 mb-2">
          {label}
        </label>
      )}
      <textarea
        rows={rows}
        className={cn(
          baseStyles,
          stateStyles,
          className
        )}
        {...props}
      />
      {error && (
        <p className="mt-2 text-sm text-red-600">{error}</p>
      )}
      {helperText && !error && (
        <p className="mt-2 text-sm text-gray-500">{helperText}</p>
      )}
    </div>
  );
};

export default StandardTextarea;